import { formatCurrency } from '@instamenu/formatters';

export function formatSignedCurrency(amount: number) {
  return `${amount > 0 ? '+' : ''}${formatCurrency(amount)}`;
}

export function hasCashRoundingAdjustment(amount: number) {
  return amount !== 0;
}

export function totalCollectedWithCashRounding({
  netTotal,
  invoiceNetTotal,
  giftCardSales,
  cashRoundingAdjustment,
}: {
  netTotal: number;
  invoiceNetTotal: number;
  giftCardSales: number;
  cashRoundingAdjustment: number;
}) {
  return netTotal + invoiceNetTotal + giftCardSales + cashRoundingAdjustment;
}
